module.exports = __webpack_public_path__ + "img/56.cd5f8612.jpg";